module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods checks"
  }, [_c('el-dialog', {
    attrs: {
      "title": "库存明细",
      "visible": _vm.dialogTableVisibletable
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisibletable = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData,
      "height": "200"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "Id",
      "align": "center",
      "label": "订单编号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "Remark",
      "align": "center",
      "label": "订单类型",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "CTime",
      "align": "center",
      "label": "日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "Counts",
      "align": "center",
      "label": "库存状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "AllCounts",
      "align": "center",
      "label": "剩余"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px",
      "margin-left": "43%",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisibletable = false
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGoods),
      expression: "isGoods"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "21px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0 12px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticClass: "lablepadding",
    staticStyle: {
      "margin-top": "0px",
      "display": "flex",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "关键词语："
    }
  }, [_c('el-input', {
    staticStyle: {
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "title": _vm.filters.name,
      "placeholder": "商品编码 / 标题"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select letter",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "品 牌 商："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.options3,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.pinpaishang),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pinpaishang", $$v)
      },
      expression: "filters.pinpaishang"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "商品品类："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "lablepadding",
    staticStyle: {
      "display": "flex",
      "position": "relative"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "商品品牌："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "商品状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.xuanstatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "xuanstatusId", $$v)
      },
      expression: "filters.xuanstatusId"
    }
  }, _vm._l((_vm.statusptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "销售类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.goodsActiveId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "goodsActiveId", $$v)
      },
      expression: "filters.goodsActiveId"
    }
  }, _vm._l((_vm.xiaoshouoptions1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {}, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticClass: "toolbar_search",
    staticStyle: {
      "border-color": "none",
      "height": "36px",
      "line-height": "1px"
    },
    on: {
      "click": _vm.onsubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), [_c('el-col', {
    staticClass: "goods_table pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('p', {
    staticClass: "model_top_title",
    attrs: {
      "sty": ""
    }
  }, [_vm._v("快捷操作")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "22px",
      "margin-top": "15px",
      "padding-right": "22px"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1189) > -1),
      expression: "menuAction.indexOf(1189)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(0)
      }
    }
  }, [_vm._v("上 架")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1190) > -1),
      expression: "menuAction.indexOf(1190)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(1)
      }
    }
  }, [_vm._v("下 架")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1191) > -1),
      expression: "menuAction.indexOf(1191)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(2)
      }
    }
  }, [_vm._v("首页展示")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1192) > -1),
      expression: "menuAction.indexOf(1192)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(3)
      }
    }
  }, [_vm._v("取消首页展示")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1193) > -1),
      expression: "menuAction.indexOf(1193)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(4)
      }
    }
  }, [_vm._v("今日推荐")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1194) > -1),
      expression: "menuAction.indexOf(1194)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(5)
      }
    }
  }, [_vm._v("取消今日推荐")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1197) > -1),
      expression: "menuAction.indexOf(1197)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(8)
      }
    }
  }, [_vm._v("置 顶")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1198) > -1),
      expression: "menuAction.indexOf(1198)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.BatchGoods(9)
      }
    }
  }, [_vm._v("取消置顶")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1199) > -1),
      expression: "menuAction.indexOf(1199)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": _vm.setnumber
    }
  }, [_vm._v("调价")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1200) > -1),
      expression: "menuAction.indexOf(1200)>-1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.scokt()
      }
    }
  }, [_vm._v("调库存")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1211) > -1 && _vm.screenWidth >= 1530),
      expression: "menuAction.indexOf(1211)>-1&&screenWidth>=1530"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px",
      "padding": "0 5px"
    },
    on: {
      "click": function($event) {
        return _vm.congin(1)
      }
    }
  }, [_vm._v("可用优惠券")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(4250) > -1),
      expression: "menuAction.indexOf(4250) > -1"
    }],
    class: _vm.screenWidth == 1536 || _vm.screenWidth == 1535 ? 'add_new_btn butstyle1' : 'add_new_btn butstyle',
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.endRecom()
      }
    }
  }, [_vm._v("商品推荐")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenWidth < 1530),
      expression: "screenWidth<1530"
    }],
    staticStyle: {
      "display": "flex",
      "margin-left": "22px",
      "margin-top": "10px",
      "padding-right": "22px"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1211) > -1),
      expression: "menuAction.indexOf(1211)>-1"
    }],
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.congin(1)
      }
    }
  }, [_vm._v("可用优惠券")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1212) > -1),
      expression: "menuAction.indexOf(1212)>-1"
    }],
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "5px",
      "width": "84px"
    },
    on: {
      "click": function($event) {
        return _vm.congin(2)
      }
    }
  }, [_vm._v("可享会员折扣")])]), _vm._v(" "), _c('div', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuAction.indexOf(1188) > -1),
      expression: "menuAction.indexOf(1188)>-1"
    }],
    staticClass: "add_new_btn",
    staticStyle: {
      "width": "80px"
    },
    on: {
      "click": function($event) {
        return _vm.showNext()
      }
    }
  }, [_vm._v("+新 增")])]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container"
  }, [_c('el-table', {
    staticClass: "goods_tab",
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.users,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "产品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode,
            "label": scope.row.GoodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Title",
      "label": "名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Title,
            "label": scope.row.Title
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandBusinessName",
      "label": "所属品牌商",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandBusinessName
          }
        }, [_vm._v(_vm._s(scope.row.BrandBusinessName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName
          }
        }, [_vm._v(_vm._s(scope.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandTypeName",
      "label": "所属品类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.BrandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "甄惠装价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": '￥' + scope.row.TzrPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.TzrPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "市场价格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": '￥' + scope.row.MarketPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.MarketPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsTopName",
      "label": "是否置顶",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.IsTopName
          }
        }, [_vm._v(_vm._s(scope.row.IsTopName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsUseCouponName",
      "label": "可用优惠券",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.IsUseCouponName
          }
        }, [_vm._v(_vm._s(scope.row.IsUseCouponName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsShowHomeName",
      "label": "首页展示",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.IsShowHomeName
          }
        }, [_vm._v(_vm._s(scope.row.IsShowHomeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsTodayName",
      "label": "今日推荐",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.IsTodayName
          }
        }, [_vm._v(_vm._s(scope.row.IsTodayName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Stock",
      "label": "库存",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Stock
          }
        }, [_vm._v(_vm._s(scope.row.Stock))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodsActiveName",
      "label": "销售类型",
      "width": "72px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsActiveName
          }
        }, [_vm._v(_vm._s(scope.row.GoodsActiveName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StatusName",
      "label": "状态",
      "width": "59px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.StatusName
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "width": "250px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "goods_operations action_container"
        }, [(_vm.menuAction.indexOf(61) > -1) ? _c('p', {
          on: {
            "click": function($event) {
              return _vm.chakan(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("\n                      查看\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.menuAction.indexOf(62) > -1) ? _c('p', {
          on: {
            "click": function($event) {
              return _vm.endEdit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("\n                      编辑\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.menuAction.indexOf(1201) > -1) ? _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.volume(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-setting"
        }), _vm._v("\n                      销量\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.menuAction.indexOf(1202) > -1) ? _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.comment(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        }), _vm._v("\n                      评价\n                    ")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar_footer",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])]], 2), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdd),
      expression: "isAdd"
    }],
    staticClass: "add_goods pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.shownew) ? _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理新增")]) : _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理编辑")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "add_all"
  }, [_c('div', {
    staticClass: "goods_msg"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("商品基本信息")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "msg_content content"
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "品　　类:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getbrandarr1
    },
    model: {
      value: (_vm.newpinleiId),
      callback: function($$v) {
        _vm.newpinleiId = $$v
      },
      expression: "newpinleiId"
    }
  }, _vm._l((_vm.newpinleioptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42.5%",
      "margin-left": "35px",
      "display": "flex"
    },
    attrs: {
      "label": "品　　牌:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newpinpaiId),
      callback: function($$v) {
        _vm.newpinpaiId = $$v
      },
      expression: "newpinpaiId"
    }
  }, _vm._l((_vm.addbrand), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "产品型号:",
      "rules": [{
        required: true
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "50",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.GoodModelCode),
      callback: function($$v) {
        _vm.GoodModelCode = $$v
      },
      expression: "GoodModelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form', {
    staticClass: "changstyle"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "详情页产品图片:",
      "label-width": "102px",
      "rules": [{
        required: true
      }]
    }
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_c('draggable', {
    attrs: {
      "options": {
        animation: 500
      }
    },
    on: {
      "update": _vm.dragDetailsPic
    },
    model: {
      value: (_vm.detailImgUrlarr1),
      callback: function($$v) {
        _vm.detailImgUrlarr1 = $$v
      },
      expression: "detailImgUrlarr1"
    }
  }, [_c('transition-group', _vm._l((_vm.detailImgUrlarr1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      attrs: {
        "data-img": item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "10px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), 0)], 1), _vm._v(" "), (_vm.flag < 20) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "list-type": "picture-card",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    ref: "big1",
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                  建议分类竖图尺寸750px*750px以上且比例为1：1，商品详情图尺寸为支持jpg、png等格式\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "标　　题:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Title),
      callback: function($$v) {
        _vm.Title = $$v
      },
      expression: "Title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "45px",
      "display": "flex"
    },
    attrs: {
      "label": "标　　语:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Slogan),
      callback: function($$v) {
        _vm.Slogan = $$v
      },
      expression: "Slogan"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "产品库存:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "8",
      "show-word-limit": "",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')"
    },
    model: {
      value: (_vm.form.weistock),
      callback: function($$v) {
        _vm.$set(_vm.form, "weistock", $$v)
      },
      expression: "form.weistock"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42.5%",
      "margin-left": "35px",
      "display": "flex"
    },
    attrs: {
      "label": "单　　位:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.danweiId),
      callback: function($$v) {
        _vm.danweiId = $$v
      },
      expression: "danweiId"
    }
  }, _vm._l((_vm.danwei), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "41%",
      "margin-left": "73px",
      "display": "flex"
    },
    attrs: {
      "label": "产品优势:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Advantage),
      callback: function($$v) {
        _vm.Advantage = $$v
      },
      expression: "Advantage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "50px",
      "display": "flex"
    },
    attrs: {
      "label": "备　　注:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Remark),
      callback: function($$v) {
        _vm.Remark = $$v
      },
      expression: "Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "msg_form"
  }, [_c('el-form-item', {
    staticClass: "color_msg width100",
    staticStyle: {
      "margin-left": "21px"
    },
    attrs: {
      "label": "颜　　色:",
      "label-width": "105px",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('div', {
    staticClass: "table_color_box",
    staticStyle: {
      "width": "76.5%"
    }
  }, [_c('div', {
    staticClass: "item",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "color",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "img_vox",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("图片")]), _vm._v(" "), _c('div', {
    staticClass: "action_del",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.colorList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-around"
      }
    }, [_c('div', {
      staticClass: "color"
    }, [_c('el-input', {
      style: (_vm.screenWidth >= 1918 ? 'width:456px' : 'width:250px'),
      attrs: {
        "maxlength": "50",
        "show-word-limit": ""
      },
      model: {
        value: (_vm.colorList[index].ImgName),
        callback: function($$v) {
          _vm.$set(_vm.colorList[index], "ImgName", $$v)
        },
        expression: "colorList[index].ImgName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "img_vox",
      on: {
        "click": function($event) {
          return _vm.imgchaun(index)
        }
      }
    }, [_c('el-upload', {
      staticClass: "table_pic",
      style: (_vm.screenWidth >= 1918 ? 'margin-left:284px' : ''),
      attrs: {
        "action": "",
        "list-type": "picture-card",
        "index": index,
        "before-upload": _vm.beforeAvatarUpload1
      }
    }, [(_vm.colorList[index].ImgData) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.BaseUrl + _vm.colorList[index].ImgData,
        "width": "100%"
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "action_del",
      style: (_vm.screenWidth >= 1918 ? 'margin-left:405px' : '')
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.delColor(index)
        }
      }
    }, [_vm._v("删除")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "color_btn",
    on: {
      "click": _vm.addColor
    }
  }, [_vm._v("新增")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "margin-left": "21px",
      "width": "36.5%"
    },
    attrs: {
      "label": "物流方式:",
      "prop": "name",
      "label-width": "105px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.wuliuId),
      callback: function($$v) {
        _vm.wuliuId = $$v
      },
      expression: "wuliuId"
    }
  }, _vm._l((_vm.wuliu), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "margin-left": "21px",
      "width": "36.5%"
    },
    attrs: {
      "label": "运费说明:",
      "label-width": "105px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.FreightDesc),
      callback: function($$v) {
        _vm.FreightDesc = $$v
      },
      expression: "FreightDesc"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_parameter"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("商品详情 / 参数")])])], 1), _vm._v(" "), (_vm.quyuarr.length > 0) ? _c('div', {
    staticClass: "parameter_content content"
  }, [_c('el-form', {
    staticClass: "parameter_form"
  }, _vm._l((_vm.quyuarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "parameter_form_l"
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 1),
        expression: "item.ControlTypeId==1"
      }],
      attrs: {
        "label": item.Name,
        "prop": "name",
        "label-width": "105px"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "360px"
      },
      attrs: {
        "maxlength": "50"
      },
      model: {
        value: (_vm.GoodsParams[index].DataValue),
        callback: function($$v) {
          _vm.$set(_vm.GoodsParams[index], "DataValue", $$v)
        },
        expression: "GoodsParams[index].DataValue"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 3),
        expression: "item.ControlTypeId==3"
      }],
      attrs: {
        "label": item.Name,
        "label-width": "105px"
      }
    }, [_c('div', {
      staticClass: "whether"
    }, [_c('div', [_c('i', [_c('img', {
      attrs: {
        "src": item.sel ? _vm.src2 : _vm.src1,
        "alt": "",
        "bangding": index,
        "selId": _vm.quyuarr[index]
      },
      on: {
        "click": function($event) {
          return _vm.changeImg(index, 0)
        }
      }
    })]), _vm._v("\n                    是\n                  ")]), _vm._v(" "), _c('div', [_c('i', [_c('img', {
      attrs: {
        "src": item.sel ? _vm.src1 : _vm.src2,
        "bangding": index,
        "selId": _vm.quyuarr[index],
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeImg(index, 1)
        }
      }
    })]), _vm._v("\n                    否\n                  ")])])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 2),
        expression: "item.ControlTypeId==2"
      }],
      attrs: {
        "label": item.Name,
        "label-width": "105px"
      }
    }, [_c('el-select', {
      staticStyle: {
        "background": "#fff"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.GoodsParams[index].DataValue),
        callback: function($$v) {
          _vm.$set(_vm.GoodsParams[index], "DataValue", $$v)
        },
        expression: "GoodsParams[index].DataValue"
      }
    }, _vm._l((item.BaseDatas), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      })
    }), 1)], 1)], 1)
  }), 0)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods_shop"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("\n              商品详情/其他参数\n              "), _c('span', {
    staticStyle: {
      "color": "#bfbfbf",
      "font-size": "12px",
      "margin-left": "20px"
    }
  }, [_vm._v("添加更多商品参数，若无可不填写")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "shop_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "其他参数:"
    }
  }, [_c('div', {
    staticClass: "table_color_box"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "text-align": "90px",
      "padding": "10px 15px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "width": "300px",
      "padding": "10px 15px"
    }
  }, [_vm._v("参数名称")]), _vm._v(" "), _c('div', {
    staticClass: "img_vox"
  }, [_vm._v("值")]), _vm._v(" "), _c('div', {
    staticClass: "action_del"
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.othertable), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "width": "60px",
        "text-align": "90px",
        "padding": "10px 15px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "color"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "maxlength": "50"
      },
      model: {
        value: (_vm.othertable[index].PName),
        callback: function($$v) {
          _vm.$set(_vm.othertable[index], "PName", $$v)
        },
        expression: "othertable[index].PName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "img_vox"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "maxlength": "50"
      },
      model: {
        value: (_vm.othertable[index].PValue),
        callback: function($$v) {
          _vm.$set(_vm.othertable[index], "PValue", $$v)
        },
        expression: "othertable[index].PValue"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "action_del"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.delother(index)
        }
      }
    }, [_vm._v("删除")])])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addothers),
      expression: "addothers"
    }],
    staticClass: "shop_btn",
    on: {
      "click": function($event) {
        return _vm.addother()
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('div', {
    staticClass: "shop_btn",
    staticStyle: {
      "padding": "0 5px"
    },
    on: {
      "click": function($event) {
        return _vm.deleteother()
      }
    }
  }, [_vm._v("全部删除")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("产品优势")])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "advantage_pic"
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片:",
      "label-width": "80px"
    }
  }, [_c('draggable', {
    attrs: {
      "options": {
        animation: 500
      }
    },
    on: {
      "update": _vm.dragAdvantagePic
    },
    model: {
      value: (_vm.youImgUrlarr1),
      callback: function($$v) {
        _vm.youImgUrlarr1 = $$v
      },
      expression: "youImgUrlarr1"
    }
  }, [_c('transition-group', _vm._l((_vm.youImgUrlarr1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      attrs: {
        "data-img": item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delyoushi(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), 0)], 1), _vm._v(" "), (_vm.flag2 < 30) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "list-type": "picture-card",
      "before-upload": _vm.handleproductyou,
      "limit": 5,
      "on-exceed": _vm.handleExceed,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式\n              ")])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advantage),
      expression: "advantage"
    }],
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("应用效果")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:"
    }
  }, [_vm._l((_vm.xiaoguoImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "20px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delxiaoguo(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "",
      "list-type": "picture-card",
      "on-change": _vm.handlexiaoguo,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip xijie",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                  PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式\n                ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advantage),
      expression: "advantage"
    }],
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("产品细节")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:"
    }
  }, [_vm._l((_vm.xijieImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "20px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delxijieimg(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "",
      "list-type": "picture-card",
      "on-change": _vm.handlexijie,
      "accept": ".png, .jpg ,.jpeg"
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip xijie",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                  PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式\n                ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("产品检测报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:",
      "label-width": "80px"
    }
  }, [_c('draggable', {
    attrs: {
      "options": {
        animation: 500
      }
    },
    on: {
      "update": _vm.dragTestingPic
    },
    model: {
      value: (_vm.jianceImgUrlarr1),
      callback: function($$v) {
        _vm.jianceImgUrlarr1 = $$v
      },
      expression: "jianceImgUrlarr1"
    }
  }, [_c('transition-group', _vm._l((_vm.jianceImgUrlarr1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      attrs: {
        "data-img": item
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "10px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deljianceimg(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), 0)], 1), _vm._v(" "), (_vm.flag3 < 30) ? _c('el-upload', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "action": "",
      "multiple": "",
      "list-type": "picture-card",
      "before-upload": _vm.handlejiance,
      "limit": 5,
      "on-exceed": _vm.handleExceed,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                  PC宽度为0~1200px，小程序宽度为700px，支持jpg、png等格式\n                ")])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_shop"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods_policy"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("售后政策")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "policy_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "售后政策:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "500",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.AfterPolicy),
      callback: function($$v) {
        _vm.AfterPolicy = $$v
      },
      expression: "AfterPolicy"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_policy"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("注意事项")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "policy_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "注意事项:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "500",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.NeedAttention),
      callback: function($$v) {
        _vm.NeedAttention = $$v
      },
      expression: "NeedAttention"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), (_vm.actid) ? _c('div', {
    staticClass: "goods_footer"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.showGoods()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.endBack()
      }
    }
  }, [_vm._v("下一步")])]) : _c('div', {
    staticClass: "goods_footer"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.showGoods()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.endBack()
      }
    }
  }, [_vm._v("下一步")])])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.isNext),
      expression: "isNext"
    }],
    staticClass: "add_goods_next main_container",
    attrs: {
      "id": "scoll",
      "span": 24,
      "element-loading-text": "拼命保存中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.shownew) ? _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理新增")]) : _c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理编辑")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-form', {
    ref: "editForm",
    staticClass: "next_form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.changeOption(_vm.options)
      }
    },
    model: {
      value: (_vm.options),
      callback: function($$v) {
        _vm.options = $$v
      },
      expression: "options"
    }
  }, _vm._l((_vm.xiaoshouoptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVip),
      expression: "isVip"
    }],
    staticClass: "vip"
  }, [_c('el-form-item', {
    attrs: {
      "label": "VIP价:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')"
    },
    model: {
      value: (_vm.VipPrice),
      callback: function($$v) {
        _vm.VipPrice = $$v
      },
      expression: "VipPrice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元 +")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')"
    },
    model: {
      value: (_vm.Score),
      callback: function($$v) {
        _vm.Score = $$v
      },
      expression: "Score"
    }
  }), _vm._v(" "), _c('i', [_vm._v("积分,")]), _vm._v(" "), _c('i', [_vm._v("累计分享")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')"
    },
    model: {
      value: (_vm.SharingDays),
      callback: function($$v) {
        _vm.SharingDays = $$v
      },
      expression: "SharingDays"
    }
  }), _vm._v(" "), _c('i', [_vm._v("天免积分")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSample),
      expression: "isSample"
    }],
    staticClass: "sample"
  }, [_c('el-form-item', {
    attrs: {
      "label": "市场价:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/^(\\s+|\\.+|\\D)/,'').replace(/(\\d+)(\\.)(\\d)(\\.)/,'$1$2$3').replace(/(\\d+)(\\.)(\\.)/,'$1$2').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.form.shichangprice),
      callback: function($$v) {
        _vm.$set(_vm.form, "shichangprice", $$v)
      },
      expression: "form.shichangprice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "甄惠装价:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/^(\\s+|\\.+|\\D)/,'').replace(/(\\d+)(\\.)(\\d)(\\.)/,'$1$2$3').replace(/(\\d+)(\\.)(\\.)/,'$1$2').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')"
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.form.tzprice),
      callback: function($$v) {
        _vm.$set(_vm.form, "tzprice", $$v)
      },
      expression: "form.tzprice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "佣金比例:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "maxlength": "2",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')"
    },
    model: {
      value: (_vm.form.yongjin),
      callback: function($$v) {
        _vm.$set(_vm.form, "yongjin", $$v)
      },
      expression: "form.yongjin"
    }
  }), _vm._v(" "), _c('i', [_vm._v("%")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdvance),
      expression: "isAdvance"
    }],
    staticClass: "advance"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "预售截止日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions2
    },
    model: {
      value: (_vm.yuETime),
      callback: function($$v) {
        _vm.yuETime = $$v
      },
      expression: "yuETime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "发货起始日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions3
    },
    model: {
      value: (_vm.yuSTime),
      callback: function($$v) {
        _vm.yuSTime = $$v
      },
      expression: "yuSTime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSpecial),
      expression: "isSpecial"
    }],
    staticClass: "special"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "截止日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions1
    },
    model: {
      value: (_vm.ETime),
      callback: function($$v) {
        _vm.ETime = $$v
      },
      expression: "ETime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "next_footer"
  }, [(_vm.shownew) ? _c('p', {
    on: {
      "click": _vm.editSubmit
    }
  }, [_vm._v("保 存")]) : _c('p', {
    on: {
      "click": _vm.bianSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.shownew) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.showAdd()
      }
    }
  }, [_vm._v("上一步")]) : _c('p', {
    on: {
      "click": function($event) {
        return _vm.editAdd()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "background": "#fff",
      "color": "#F56C6C",
      "border": "1px solid #F56C6C"
    },
    on: {
      "click": _vm.cancelmodel
    }
  }, [_vm._v("取 消")])])], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ischaNext),
      expression: "ischaNext"
    }],
    staticClass: "add_goods_next main_container",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理查看")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-form', {
    ref: "editForm",
    staticClass: "next_form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    on: {
      "change": function($event) {
        return _vm.changeOption(_vm.options)
      }
    },
    model: {
      value: (_vm.options),
      callback: function($$v) {
        _vm.options = $$v
      },
      expression: "options"
    }
  }, _vm._l((_vm.xiaoshouoptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSample),
      expression: "isSample"
    }],
    staticClass: "sample"
  }, [_c('el-form-item', {
    attrs: {
      "label": "市场价:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')",
      "disabled": true
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.form.shichangprice),
      callback: function($$v) {
        _vm.$set(_vm.form, "shichangprice", $$v)
      },
      expression: "form.shichangprice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "甄惠装价:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')",
      "disabled": true
    },
    on: {
      "blur": function($event) {
        return _vm.changeblur()
      }
    },
    model: {
      value: (_vm.form.tzprice),
      callback: function($$v) {
        _vm.$set(_vm.form, "tzprice", $$v)
      },
      expression: "form.tzprice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "佣金比例:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "maxlength": "2",
      "disabled": true,
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')"
    },
    model: {
      value: (_vm.form.yongjin),
      callback: function($$v) {
        _vm.$set(_vm.form, "yongjin", $$v)
      },
      expression: "form.yongjin"
    }
  }), _vm._v(" "), _c('i', [_vm._v("%")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')",
      "disabled": true
    },
    model: {
      value: (_vm.form.weistock),
      callback: function($$v) {
        _vm.$set(_vm.form, "weistock", $$v)
      },
      expression: "form.weistock"
    }
  }), _vm._v(" "), _c('i', [_vm._v("个")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdvance),
      expression: "isAdvance"
    }],
    staticClass: "advance"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "预售截止日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions2,
      "disabled": true
    },
    model: {
      value: (_vm.yuETime),
      callback: function($$v) {
        _vm.yuETime = $$v
      },
      expression: "yuETime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "发货起始日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions3,
      "disabled": true
    },
    model: {
      value: (_vm.yuSTime),
      callback: function($$v) {
        _vm.yuSTime = $$v
      },
      expression: "yuSTime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSpecial),
      expression: "isSpecial"
    }],
    staticClass: "special"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "截止日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions1,
      "disabled": true
    },
    model: {
      value: (_vm.ETime),
      callback: function($$v) {
        _vm.ETime = $$v
      },
      expression: "ETime"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVip),
      expression: "isVip"
    }],
    staticClass: "vip"
  }, [_c('el-form-item', {
    attrs: {
      "label": "VIP价:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.VipPrice),
      callback: function($$v) {
        _vm.VipPrice = $$v
      },
      expression: "VipPrice"
    }
  }), _vm._v(" "), _c('i', [_vm._v("元 +")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.Score),
      callback: function($$v) {
        _vm.Score = $$v
      },
      expression: "Score"
    }
  }), _vm._v(" "), _c('i', [_vm._v("积分,")]), _vm._v(" "), _c('i', [_vm._v("累计分享")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "144px"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.SharingDays),
      callback: function($$v) {
        _vm.SharingDays = $$v
      },
      expression: "SharingDays"
    }
  }), _vm._v(" "), _c('i', [_vm._v("天免积分")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "next_footer"
  }, [_c('p', {
    on: {
      "click": _vm.confirmView
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "background": "#fff",
      "color": "#F56C6C",
      "border": "1px solid #F56C6C"
    },
    on: {
      "click": _vm.seecancelmodel
    }
  }, [_vm._v("取 消")])])], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ischaAdd),
      expression: "ischaAdd"
    }],
    staticClass: "add_goods pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理查看")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "add_all"
  }, [_c('div', {
    staticClass: "goods_msg"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("商品基本信息")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "msg_content content"
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "品　　类:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "disabled": true
    },
    on: {
      "change": function($event) {
        return _vm.selectpinlei(_vm.newpinleiId)
      }
    },
    model: {
      value: (_vm.newpinleiId),
      callback: function($$v) {
        _vm.newpinleiId = $$v
      },
      expression: "newpinleiId"
    }
  }, _vm._l((_vm.newpinleioptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42.5%",
      "margin-left": "35px",
      "display": "flex"
    },
    attrs: {
      "label": "品　　牌:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newpinpaiId),
      callback: function($$v) {
        _vm.newpinpaiId = $$v
      },
      expression: "newpinpaiId"
    }
  }, _vm._l((_vm.newpinpaioptions.agentBrandList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "产品型号:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.GoodModelCode),
      callback: function($$v) {
        _vm.GoodModelCode = $$v
      },
      expression: "GoodModelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form', {
    staticClass: "changstyle"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "详情页产品图片:",
      "label-width": "102px",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "10px",
        "margin-top": "5px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    })], 1)])
  }), _vm._v(" "), (_vm.flag < 20) ? _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "action": "",
      "multiple": "",
      "list-type": "picture-card",
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.form.ImgUrl) ? _c('img', {
    ref: "big1",
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ImgUrl,
      "width": "100%"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v("\n                  建议分类竖图尺寸750px*750px以上且比例为1：1，商品详情图尺寸为支持jpg、png等格式\n                ")])]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "标　　题:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Title),
      callback: function($$v) {
        _vm.Title = $$v
      },
      expression: "Title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "45px",
      "display": "flex"
    },
    attrs: {
      "label": "标　　语:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "maxlength": "30",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Slogan),
      callback: function($$v) {
        _vm.Slogan = $$v
      },
      expression: "Slogan"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "64px",
      "display": "flex"
    },
    attrs: {
      "label": "产品库存:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'')"
    },
    model: {
      value: (_vm.form.weistock),
      callback: function($$v) {
        _vm.$set(_vm.form, "weistock", $$v)
      },
      expression: "form.weistock"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42.5%",
      "margin-left": "35px",
      "display": "flex"
    },
    attrs: {
      "label": "单　　位:",
      "rules": [{
        required: true
      }],
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.danweiId),
      callback: function($$v) {
        _vm.danweiId = $$v
      },
      expression: "danweiId"
    }
  }, _vm._l((_vm.danwei), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "41%",
      "margin-left": "73px",
      "display": "flex"
    },
    attrs: {
      "label": "产品优势:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true,
      "maxlength": "60",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Advantage),
      callback: function($$v) {
        _vm.Advantage = $$v
      },
      expression: "Advantage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "width": "42%",
      "margin-left": "50px",
      "display": "flex"
    },
    attrs: {
      "label": "备　　注:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true,
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.Remark),
      callback: function($$v) {
        _vm.Remark = $$v
      },
      expression: "Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "msg_form"
  }, [_c('el-form-item', {
    staticClass: "color_msg",
    staticStyle: {
      "margin-left": "21px"
    },
    attrs: {
      "label": "颜色:",
      "rules": [{
        required: true
      }],
      "prop": "",
      "label-width": "105px"
    }
  }, [_c('div', {
    staticClass: "table_color_box",
    staticStyle: {
      "width": "76.5%"
    }
  }, [_c('div', {
    staticClass: "item",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "color",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "img_vox",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("图片")]), _vm._v(" "), _c('div', {
    staticClass: "action_del",
    style: (_vm.screenWidth >= 1918 ? 'margin-left:144px' : '')
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.colorList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-around"
      }
    }, [_c('div', {
      staticClass: "color"
    }, [_c('el-input', {
      style: (_vm.screenWidth >= 1918 ? 'width:456px' : 'width:250px'),
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.colorList[index].ImgName),
        callback: function($$v) {
          _vm.$set(_vm.colorList[index], "ImgName", $$v)
        },
        expression: "colorList[index].ImgName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "img_vox",
      on: {
        "click": function($event) {
          return _vm.imgchaun(index)
        }
      }
    }, [_c('el-upload', {
      staticClass: "table_pic",
      style: (_vm.screenWidth >= 1918 ? 'margin-left:284px' : ''),
      attrs: {
        "action": "",
        "list-type": "picture-card",
        "index": index,
        "disabled": true
      }
    }, [(_vm.colorList[index].ImgData) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.BaseUrl + _vm.colorList[index].ImgData,
        "width": "100%"
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "action_del",
      style: (_vm.screenWidth >= 1918 ? 'margin-left:405px' : '')
    }, [_c('span', [_vm._v("删除")])])])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "margin-left": "21px",
      "width": "36.5%"
    },
    attrs: {
      "label": "物流方式:",
      "prop": "name",
      "label-width": "105px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    model: {
      value: (_vm.wuliuId),
      callback: function($$v) {
        _vm.wuliuId = $$v
      },
      expression: "wuliuId"
    }
  }, _vm._l((_vm.wuliu), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "width100",
    staticStyle: {
      "margin-left": "21px",
      "width": "36.5%"
    },
    attrs: {
      "label": "运费说明:",
      "label-width": "105px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "30",
      "show-word-limit": "",
      "disabled": true
    },
    model: {
      value: (_vm.FreightDesc),
      callback: function($$v) {
        _vm.FreightDesc = $$v
      },
      expression: "FreightDesc"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_parameter"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("商品详情 / 参数")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "parameter_content content"
  }, [_c('el-form', {
    staticClass: "parameter_form"
  }, _vm._l((_vm.quyuarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "parameter_form_l"
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 1),
        expression: "item.ControlTypeId==1"
      }],
      attrs: {
        "label": item.Name,
        "prop": "name",
        "label-width": "105px"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "360px"
      },
      attrs: {
        "maxlength": "50",
        "disabled": true
      },
      model: {
        value: (_vm.GoodsParams[index].DataValue),
        callback: function($$v) {
          _vm.$set(_vm.GoodsParams[index], "DataValue", $$v)
        },
        expression: "GoodsParams[index].DataValue"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 3),
        expression: "item.ControlTypeId==3"
      }],
      attrs: {
        "label": item.Name,
        "label-width": "105px"
      }
    }, [_c('div', {
      staticClass: "whether"
    }, [_c('div', [_c('i', [_c('img', {
      attrs: {
        "src": item.sel ? _vm.src2 : _vm.src1,
        "alt": "",
        "bangding": index,
        "selId": _vm.quyuarr[index]
      }
    })]), _vm._v("\n                    是\n                  ")]), _vm._v(" "), _c('div', [_c('i', [_c('img', {
      attrs: {
        "src": item.sel ? _vm.src1 : _vm.src2,
        "bangding": index,
        "selId": _vm.quyuarr[index],
        "alt": ""
      }
    })]), _vm._v("\n                    否\n                  ")])])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ControlTypeId == 2),
        expression: "item.ControlTypeId==2"
      }],
      attrs: {
        "label": item.Name,
        "label-width": "105px"
      }
    }, [_c('el-select', {
      staticStyle: {
        "background": "#fff"
      },
      attrs: {
        "placeholder": "请选择",
        "disabled": true
      },
      model: {
        value: (_vm.GoodsParams[index].DataValue),
        callback: function($$v) {
          _vm.$set(_vm.GoodsParams[index], "DataValue", $$v)
        },
        expression: "GoodsParams[index].DataValue"
      }
    }, _vm._l((item.BaseDatas), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      })
    }), 1)], 1)], 1)
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_shop"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("\n              商品详情/其他参数\n              "), _c('span', {
    staticStyle: {
      "color": "#bfbfbf",
      "font-size": "12px",
      "margin-left": "20px"
    }
  }, [_vm._v("添加更多商品参数，若无可不填写")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "shop_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "其他参数:"
    }
  }, [_c('div', {
    staticClass: "table_color_box"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "width": "90px",
      "text-align": "90px",
      "padding": "10px 15px"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "width": "340px",
      "padding": "10px 15px"
    }
  }, [_vm._v("参数名称")]), _vm._v(" "), _c('div', {
    staticClass: "img_vox"
  }, [_vm._v("值")]), _vm._v(" "), _c('div', {
    staticClass: "action_del"
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.othertable), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "width": "90px",
        "text-align": "90px",
        "padding": "10px 15px"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "color"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.othertable[index].PName),
        callback: function($$v) {
          _vm.$set(_vm.othertable[index], "PName", $$v)
        },
        expression: "othertable[index].PName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "img_vox"
    }, [_c('el-input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.othertable[index].PValue),
        callback: function($$v) {
          _vm.$set(_vm.othertable[index], "PValue", $$v)
        },
        expression: "othertable[index].PValue"
      }
    })], 1)])
  })], 2)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("产品优势")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:",
      "label-width": "80px"
    }
  }, [_vm._l((_vm.youImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "20px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    })], 1)])
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advantage),
      expression: "advantage"
    }],
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("应用效果")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:"
    }
  }, [_vm._l((_vm.xiaoguoImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "20px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    })], 1)])
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advantage),
      expression: "advantage"
    }],
    staticClass: "goods_advantage"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("产品细节")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage_pic"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "图片:"
    }
  }, [_vm._l((_vm.xijieImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-img": item.ImgData
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$imgPreview($event)
        }
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "20px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgData
      }
    })], 1)])
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_shop"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods_policy"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("售后政策")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "policy_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "售后政策:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "type": "textarea",
      "rows": 5,
      "disabled": true
    },
    model: {
      value: (_vm.AfterPolicy),
      callback: function($$v) {
        _vm.AfterPolicy = $$v
      },
      expression: "AfterPolicy"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_policy"
  }, [_c('div', {
    staticClass: "msg_title"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("注意事项")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "policy_content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "注意事项:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "type": "textarea",
      "rows": 5,
      "disabled": true
    },
    model: {
      value: (_vm.NeedAttention),
      callback: function($$v) {
        _vm.NeedAttention = $$v
      },
      expression: "NeedAttention"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "goods_footer"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.chashowAdd()
      }
    }
  }, [_vm._v("下一步")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uploadtop"
  }, [_c('el-dialog', {
    attrs: {
      "title": "商品评价",
      "visible": _vm.dialogVisibledelete,
      "before-close": _vm.handleClosezhun,
      "close-on-click-modal": false,
      "center": "",
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledelete = $event
      }
    }
  }, [_c('span', [
    [_c('el-table', {
      attrs: {
        "data": _vm.commentarr,
        "stripe": "",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "UserName",
        "label": "评论人姓名",
        "width": "200px",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.UserName
            }
          }, [_vm._v(_vm._s(scope.row.UserName))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "UserFace",
        "label": "评论人头像",
        "width": "200px",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('img', {
            staticStyle: {
              "width": "44px",
              "height": "44px"
            },
            attrs: {
              "src": scope.row.UserFace
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ColorName",
        "align": "center",
        "width": "120px",
        "label": "\t评价商品颜色名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.ColorName
            }
          }, [_vm._v(_vm._s(scope.row.ColorName))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "RContent",
        "width": "200px",
        "align": "center",
        "label": "评论内容"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.RContent
            }
          }, [_vm._v(_vm._s(scope.row.RContent))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "GoodSatisfaction",
        "align": "center",
        "width": "",
        "label": "\t商品评分"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.GoodSatisfaction
            }
          }, [_vm._v(_vm._s(scope.row.GoodSatisfaction))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "BusinessSatisfaction",
        "align": "center",
        "width": "",
        "label": "\t商家评分"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.BusinessSatisfaction
            }
          }, [_vm._v(_vm._s(scope.row.BusinessSatisfaction))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "CTime",
        "align": "center",
        "width": "",
        "label": "\t评价时间"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.CTime
            }
          }, [_vm._v(_vm._s(scope.row.CTime))])]
        }
      }])
    })], 1)], _vm._v(" "), _c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('el-pagination', {
      staticStyle: {
        "float": "right",
        "margin-top": "15px"
      },
      attrs: {
        "layout": "prev, pager, next",
        "page-size": 5,
        "current-page": _vm.pageIndex1,
        "total": _vm.total1
      },
      on: {
        "current-change": _vm.handleCurrentChange1
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "1px",
        "background": "#eee",
        "margin-top": "15px"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "region1",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_vm._v("评论设置")]), _vm._v(" "), _c('el-form', {
      staticClass: "elformbottom",
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('el-form-item', {
      staticClass: "elform123",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "商品颜色："
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.colorId),
        callback: function($$v) {
          _vm.colorId = $$v
        },
        expression: "colorId"
      }
    }, _vm._l((_vm.colorarr), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "elform123",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "用户头像："
      }
    }, [_c('el-upload', {
      staticClass: "avatar-uploader1",
      attrs: {
        "action": "",
        "accept": ".png, .jpg, .jpeg",
        "show-file-list": false,
        "on-success": _vm.handleAvatarSuccess,
        "before-upload": _vm.beforeAvatarUploadtouxiang
      }
    }, [(_vm.LogoUrl1) ? _c('img', {
      staticClass: "avatar",
      staticStyle: {
        "border-radius": "50%",
        "width": "100px",
        "height": "100px"
      },
      attrs: {
        "src": _vm.LogoUrl1
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon1"
    })])], 1), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#888",
        "margin-top": "0px",
        "margin-left": "81px"
      }
    }, [_vm._v("建议尺寸：132*132，支持的图片格式：jpg、png。")]), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "用户名称："
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": "30",
        "placeholder": "请输入用户名称"
      },
      model: {
        value: (_vm.UserName),
        callback: function($$v) {
          _vm.UserName = $$v
        },
        expression: "UserName"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "评价内容："
      }
    }, [_c('el-input', {
      staticStyle: {
        "min-height": "88px !important"
      },
      attrs: {
        "type": "textarea",
        "autosize": {
          minRows: 2,
          maxRows: 6
        },
        "maxlength": "500",
        "placeholder": "请输入评价内容"
      },
      model: {
        value: (_vm.RContent),
        callback: function($$v) {
          _vm.RContent = $$v
        },
        expression: "RContent"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "商品服务："
      }
    }, [_c('el-rate', {
      attrs: {
        "colors": _vm.colorred
      },
      model: {
        value: (_vm.value1),
        callback: function($$v) {
          _vm.value1 = $$v
        },
        expression: "value1"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "商家服务："
      }
    }, [_c('el-rate', {
      attrs: {
        "colors": _vm.colorred
      },
      model: {
        value: (_vm.value2),
        callback: function($$v) {
          _vm.value2 = $$v
        },
        expression: "value2"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "label": "评论时间："
      }
    }, [_c('el-date-picker', {
      attrs: {
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "type": "datetime",
        "editable": false,
        "placeholder": "选择日期时间"
      },
      model: {
        value: (_vm.valuetime),
        callback: function($$v) {
          _vm.valuetime = $$v
        },
        expression: "valuetime"
      }
    })], 1)], 1)
  ], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.followUp()
      }
    }
  }, [_vm._v("保 存")])], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "PC电商推荐",
      "visible": _vm.isToProductRecommendation,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToProductRecommendation = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "商品推荐:",
      "label-width": "80px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.sameBrand),
      callback: function($$v) {
        _vm.sameBrand = $$v
      },
      expression: "sameBrand"
    }
  }, [_vm._v("同品牌商品推荐")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.sameCategory),
      callback: function($$v) {
        _vm.sameCategory = $$v
      },
      expression: "sameCategory"
    }
  }, [_vm._v("同品类商品推荐")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToProductRecommendation = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editRecomSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85a78342!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/goods.vue
// module id = 1727
// module chunks = 3